<template>
  <div class="wrapper" :style="cssProps">
    <div class="loading">
      <pulse-loader
        :color="'#af7c00'"
        :size="'2em'"
        :loading="loading"
      ></pulse-loader>
    </div>
    <div class="header" v-if="!loading">
      <img :src="backIcon" @click="back" class="back" />
      <parkenda-menu class="menu"></parkenda-menu>
    </div>
    <div class="content" v-if="!loading">
      <div class="label" v-if="cards && cards.length > 0">
        <p class="text">{{ this.$store.getters.TRANSLATIONS["vouchers"] }}</p>
      </div>
      <p class="content_title" v-if="cards.length > 0">
        {{ this.$store.getters.TRANSLATIONS["select_voucher_to_apply"] }}
      </p>
      <div v-if="cards && cards.length <= 0">
        <!-- No vouchers -->
        <img :src="logoIcon" class="logo" />
        <div class="message_block">
          <p class="first_text">
            {{ this.$store.getters.TRANSLATIONS["you_have_no_vouchers"] }}
            <br />{{ this.$store.getters.TRANSLATIONS["right_now"] }}
          </p>
          <div class="separator"></div>
          <p class="second_text">
            {{ this.$store.getters.TRANSLATIONS["organizations_can_send"] }}
            <br />{{ this.$store.getters.TRANSLATIONS["pay_for_valet"] }}
          </p>
        </div>
      </div>
      <div
        class="car"
        v-for="item in cards"
        :key="item.id"
        v-on:click="next(item)"
      >
        <div class="model">
          <button class="button">
            <p>{{ item.code }}</p>
          </button>
        </div>
      </div>
    </div>
    <div class="footer" v-if="!loading"></div>
    <v-dialog style="margin-top: 25%" :width="350" />
    <parkenda-toolbar></parkenda-toolbar>
  </div>
</template>

<script>
export default {
  created() {
    this.loading = true;
    this.$http
      .get(`${process.env.SERVER_URL}/E6A0FB9DE7E74C44B90F93B9049CAF12`, {
        headers: {
          "x-access-token": this.$storage.get("parkendaToken")
        }
      })
      .then((response) => {
        console.log("Get user loyalty campaign vouchers response:");
        console.log(response);
        if (response.data) {
          this.cards = response.data;
        }
      })
      .finally(() => {
        this.loading = false;
      });
  },
  data() {
    return {
      code: "",
      loading: false,
      cards: [],
      cssProps: {
        backgroundImage: `url(${require("@/assets/new_design/AdobeStock_317642058.png")})`,
        "background-position": "center",
        "background-repeat": "no-repeat",
        "background-size": "cover"
      },
      logoIcon: require("@/assets/new_design/Parkenda_VerticalLogo_FullColour.png"),
      backIcon: require("@/assets/new_design/Polygon_3.png"),
      proceed: (item) => {
        const timeout = setTimeout(() => {
          this.loading = true;
        }, 0);
        this.$http
          .post(
            `${process.env.SERVER_URL}/E730B085B3604A52A1A5D8A3135ABBD9/${this.$store.getters.REQUESTED_VEHICLE_INFO.onDemandId}`,
            {
              code: item.code,
              userId: this.config.systemUserId
            },
            {
              headers: {
                "x-access-token": this.$storage.get("parkendaToken")
              }
            }
          )
          .then((response) => {
            console.log("Apply voucher response:");
            console.log(response);
            if (response && response.status === 200) {
              this.$router.push("/appRating?returnTo=parkingReceiptFinal");
              // this.$router.push("/parkingReceiptFinal");
            }
          })
          .catch((error) => {
            let text = this.$store.getters.TRANSLATIONS["code_not_valid"];
            this.$modal.show("dialog", {
              text,
              buttons: [
                {
                  title: "OK",
                  handler: () => {
                    this.$router.push("/selectPayment");
                  }
                }
              ]
            });
          })
          .finally(() => {
            clearTimeout(timeout);
            this.loading = false;
          });
      },
      next: (item) => {
        console.log("HERE");
        console.log(this.$storage.get("lastParkingTip"));
        if (
          this.$storage.get("lastParkingTip") &&
          this.$storage.get("lastParkingTip") > 0
        ) {
          this.$modal.show("dialog", {
            text: this.$store.getters.TRANSLATIONS["by_using_loyalty"],
            buttons: [
              {
                title: "NO",
                handler: () => {
                  this.$modal.hide("dialog");
                }
              },
              {
                title: "YES",
                handler: () => {
                  this.$modal.hide("dialog");
                  this.$store.dispatch("SAVE_LAST_PARKING_TIP", 0);
                  return this.proceed(item);
                  // Remove tip
                  // const timeout = setTimeout(() => {
                  //   this.loading = true;
                  // }, 0);
                  // this.$http
                  //   .post(
                  //     `${process.env.SERVER_URL}/79fe0c5cf33e4de183b2c42510673434`,
                  //     {
                  //       paymentStatusId: this.$storage.get(
                  //         "requestedVehicleInfo"
                  //       ).id
                  //     },
                  //     {
                  //       headers: {
                  //         "x-access-token": this.$storage.get("parkendaToken")
                  //       }
                  //     }
                  //   )
                  //   .then((response) => {
                  //     console.log("Remove tip response:");
                  //     console.log(response);
                  //     this.$store.dispatch("SAVE_LAST_PARKING_TIP", 0);
                  //     return this.proceed(item);
                  //   })
                  //   .catch((error) => {
                  //     let text =
                  //       this.$store.getters.TRANSLATIONS["can_not_remove_tip"];
                  //     if (
                  //       error.response &&
                  //       error.response.data &&
                  //       error.response.data.message
                  //     ) {
                  //       text = error.response.data.message;
                  //     }
                  //     this.$modal.show("dialog", {
                  //       text,
                  //       buttons: [
                  //         {
                  //           title: "OK",
                  //           handler: () => {
                  //             this.$router.push("/home");
                  //           }
                  //         }
                  //       ]
                  //     });
                  //   })
                  //   .finally(() => {
                  //     clearTimeout(timeout);
                  //     this.loading = false;
                  //   });
                }
              }
            ]
          });
        } else {
          this.proceed(item);
        }
      },
      back: () => {
        this.$router.go(-1);
      },
      icon: require("@/assets/icon_back.png")
    };
  }
};
</script>

<style scoped src="../../styles/main.css"></style>
<style scoped>
.button {
  width: 80%;
  background-color: #72aeff;
}
.apply_button {
  background-color: #fbae31;
  width: 50%;
}
.message_block {
  border: 1px solid #fbae31;
  border-radius: 30px;
  padding: 15px 10px;
  width: 80vw;
  margin: 10vh auto 0;
}
.first_text {
  margin: 10px;
  color: #fbae31;
}
.second_text {
  margin: 10px;
  color: #fbae31;
}
.separator {
  height: 1px;
  width: 30vw;
  background-color: #fbae31;
  margin: 0 auto;
}
.logo {
  width: 25%;
}
</style>



// WEBPACK FOOTER //
// src/components/RequestCar/ApplyVoucher.vue